import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';

import { SharedModule } from '../../_modules/shared.module';
import {
  RsMenuComponent,
  RsMenuItemComponent,
  RsMenuTitleComponent,
} from './menu.component';

@NgModule({
  imports: [
    SharedModule,
    RsMenuComponent,
    RsMenuTitleComponent,
    RsMenuItemComponent,
    A11yModule,
  ],
  exports: [RsMenuComponent, RsMenuTitleComponent, RsMenuItemComponent],
})
export class RsMenuModule {}
